export default __webpack_public_path__ + "static/caesar-735586f4b123c255e04637aeba87ebe0.png";